import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/le-centre", label: "Le Centre" },
  { to: "/services", label: "Services" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-4"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div
          className={`flex items-center justify-between rounded-2xl px-4 sm:px-6 py-3 transition-all duration-300 ${
            scrolled
              ? "glass shadow-[0_8px_30px_-12px_rgba(11,39,66,0.15)]"
              : "bg-transparent"
          }`}
        >
          <Link to="/" className="flex items-center gap-3 group" data-testid="navbar-logo">
            <div className="relative w-12 h-12 rounded-xl bg-white flex items-center justify-center shadow-md shadow-ocean/10 border border-ocean/5 group-hover:scale-105 transition-transform overflow-hidden p-1.5">
              <img src="/logo-ssp.png" alt="Soutien Scolaire Papara" className="w-full h-full object-contain" />
            </div>
            <div className="hidden sm:block leading-tight">
              <div className="font-display font-semibold text-ocean text-base">Soutien Scolaire</div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-coral font-semibold">Papara</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`navlink-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `relative px-4 py-2 text-sm font-medium rounded-full transition-colors ${
                    isActive ? "text-ocean" : "text-ocean/65 hover:text-ocean"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {l.label}
                    {isActive && (
                      <span className="absolute left-1/2 -translate-x-1/2 bottom-0 h-[3px] w-6 rounded-full bg-coral"></span>
                    )}
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/inscription"
              className="hidden sm:inline-flex btn-pill btn-accent text-sm"
              data-testid="navbar-cta-inscription"
            >
              Inscrire mon enfant
            </Link>
            <button
              onClick={() => setOpen(!open)}
              className="lg:hidden w-10 h-10 rounded-full bg-white/80 border border-ocean/10 flex items-center justify-center text-ocean"
              data-testid="navbar-mobile-toggle"
              aria-label="Menu"
            >
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden mt-2 glass rounded-2xl p-4 space-y-1" data-testid="navbar-mobile-menu">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `block px-4 py-3 rounded-xl text-sm font-medium ${
                    isActive ? "bg-ocean text-white" : "text-ocean hover:bg-ocean/5"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/inscription" className="block btn-pill btn-accent w-full justify-center mt-2" data-testid="navbar-mobile-cta">
              Inscrire mon enfant
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
